




































































































































/*
    * Method for pupulate text input control - STARTS
    1.  browserAutocomplete     - HTML5 autocomplete attribute set to off (or any other value that is no "on").
    2.  columns                 - For arrange the add/edit form layout. Possible Views( multiCoumn 1 to 4)
    3.  counter / maxLength     - Creates counter for input length; if no number is specified, it defaults to 25. Does not apply any validation.
    4.  create                  - A boolean value that indicates whether this field is shown in the create record form. Default value is true.
    5.  currency                - Number format settings
    6.  disabled                - For create a disabled input field. Tab index 'll be -1 for this field.
    7.  edit                    - A boolean value that indicates whether this field is shown in the edit record form. Default value is true.
    8.  fieldName               - Name of the field.
    9.  formCreate              - Used to find the current operation of the popup field control.
    10. hint                    - The hint property on text fields adds the provided string beneath the text field.
    11. inline                  - Hides hint, validation errors when inline editor enabled.
    12. parentName              - Used to find the component name.
    13. placeholder             - Sets the input�s placeholder text
    14. prefix                  - Displays prefix text
    15. readonly                - For create a readonly input field. Tab index 'll be -1 for this field.
    16. record                  - Object of the field.
    17. required                - For set the current field as required field. An mandatory css class added for these fields.
    18. rules                   - Vuetify includes simple validation through the rules prop.
                                  The prop accepts an array of callbacks. While validating rules, the current v-model value will be passed to the callback.
                                  This callback should return either true or a String, the error message.
    19. showInputs              - This is using for internal purpose, to check whether all the inputs are binded.
    20. suffix                  - Displays suffix text
    21. title                   - A string that is shown on top of the table. This is optional.
    22. tooltip                 - The v-tooltip component is useful for conveying information when a user hovers over an element.
    23. tooltipList             - The v-tooltip component is useful for conveying all field information when a user hovers over an element.
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import TooltipComponents from "./../../../../../Tooltips/Tooltips.vue";
import { AppConstants as _app } from "@/shared/app.constants";

/*
    * Component's properties and events
*/
@Component({ components: { TooltipComponents } })

export default class NumberComponent extends Vue  {
     /*
        * Component's props
     */
     @Prop() readonly browserAutocomplete!: any;
     @Prop() readonly columns!: any;
     @Prop() readonly counter!: any;
     @Prop() readonly title!: any;
     @Prop() readonly create!: any;
     @Prop() readonly currency!: any;
     @Prop() readonly disabled!: any;
     @Prop() readonly edit!: any;
     @Prop() readonly fieldName!: any;
     @Prop() readonly formCreate!: any;
     @Prop() readonly hint!: any;
     @Prop() readonly inline!: any;
     @Prop() readonly maxLength!: any;
     @Prop() readonly placeholder!: any;
     @Prop() readonly parentName!: any;
     @Prop() readonly prefix!: any;
     @Prop() readonly readonly!: any;
     @Prop() readonly record!: any;
     @Prop() readonly required!: any;
     @Prop() readonly rules!: any;
     @Prop() readonly showInputs!: any;
     @Prop() readonly suffix!: any;
     @Prop() readonly tooltip!: any;
     @Prop() readonly tooltipList!: any;
     @Prop() readonly mask!: any;

    /*
        * Component's variables
    */
    private currencySettings: any =  Object.assign({}, this.$store.state.currency, this.currency);
    private tooltipOption: boolean = false;
    private tooltipIcon = false;
    private translateKey: string = "";
    private language = 'en-GB';

    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.currencySettings - number format settings
    */
    data() {
        if (this.$store) {
            //#.Check if the field is decimal
            if (this.currency.enabled) {
                this.currencySettings = Object.assign({}, this.$store.state.currency, this.currency);
                var self = this;
                //#.Null checking
                if (self.record && this.record[this.fieldName]) {
                    let value = this.record[this.fieldName];
                    this.record[this.fieldName] = value.toString().replace(new RegExp('\\' + _app.region.decimalSeparator), '.').replaceAll( _app.region.CurrencyGroupSeparator, '').replace(/\s+/g, "");
                    
                    self.record[self.fieldName] = new Intl.NumberFormat(_app.region.default, {
                            style: 'decimal', 
                            minimumFractionDigits: this.currencySettings.precision
                        }).format(self.record[self.fieldName]);  
                }
            }
        }

        return { translateKey: null, currencyFormat: this.currency, tooltipIcon: false, tooltipOption: false };

        //#.Check if the field is decimal
        //return { translateKey: null, currencyFormat: this.currency, tooltipIcon: false, tooltipOption: false };
    }

    /*
        * Define methods under the `methods` object
        * _numChange             - Method for inline editor input change
        * _tpShowTooltip         - Method for show tooltip
        * _tpRemoveTooltip       - Method for remove tooltip
    */
    _nmbFormatSettings() {
        this.currencySettings = Object.assign({}, this.$store.state.currency, this.currency);

        //#.Null checking
        if (this.record[this.fieldName] && this.currency.enabled) {
            this.currency.enabled = false;
            let value = this.record[this.fieldName];
            this.record[this.fieldName] = value.toString().replace(new RegExp('\\' + _app.region.decimalSeparator), '.').replaceAll(_app.region.CurrencyGroupSeparator, '').replace(/\s+/g, "");

            //let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + this.currencySettings.decimal + "\\s]", "gi");
            //this.record[this.fieldName] = value.toString().replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, "");

            //# Handling NaN error
            if(this.record[this.fieldName] == this.currencySettings.decimal){
                this.record[this.fieldName] = "";
            }

            //#.Number formatting
            const formatter = new Intl.NumberFormat(_app.region.default, {
                    style: 'decimal',
                    // @ts-ignore
                    //currency: this.currency,
                     // @ts-ignore
                    minimumFractionDigits: this.currencySettings.precision
                });
            this.currency.enabled = true;
            //#.Re-assign the value to the model field
            this.record[this.fieldName] = formatter.format(this.record[this.fieldName]);
        }
        return this.record[this.fieldName];
    }

    /*
        * Fetch record data
    */
    get getRecord(): any {
        return (this.record != undefined && this.record != null) ? this.record[this.fieldName] : "";
    }

    /*
        * Set record data
    */
    set getRecord(value) {
        if (this.record != undefined && this.record != null)
            this.record[this.fieldName] = value;

        if (this.$store) {
            let context = this.$store.state[this.parentName],
                records = this.record,
                result = 0;

            //#.Null checking
            if (!this.fieldName) {
                return;
            }

            let formulaObj = context.fields.filter(x => x.formula);

            if (formulaObj.length > 0) {
                //#.For checking the activate the formula builder for the field
                let field = formulaObj.find(x => x);

                if (field == undefined || !field.formula || (field.formula && field.formula.enabled != true))
                    return;

                let validField = field.formula.formula.indexOf(this.fieldName);

                if (validField == -1) {
                    return;
                }
                
                //#.For checking the formula builder fields values.
                let expression = field.formula.formula.replace(/\w+/g, function (fieldName) {
                  
                    //#.Added to avoid error if field value null or empty.
                    if (records[fieldName] == ""
                        || records[fieldName] == "0"
                        || records[fieldName] == "0.00"
                        || records[fieldName] == null) {

                        if (records[fieldName] == undefined)
                            return fieldName;
                        else
                            return 0;
                    }

                    let calculatedField = context.fields.filter(x => x.value == fieldName).find(x => x);

                    //#.For checking the activate field is currency field or not.
                    if (!calculatedField.currency || (calculatedField.currency && calculatedField.currency.enabled != true))
                        return parseFloat(records[fieldName]);

                    // @ts-ignore
                    if ((records[fieldName]).toString().indexOf(_app.region.decimalSeparator) == -1) {
                        return;
                    }

                    //#.Separator needs to be replaced based on tenant settings.
                    // @ts-ignore
                    let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + _app.region.decimalSeparator + "\\s]", "gi"),
                        value = (records[fieldName]).toString().replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, ""),
                        // @ts-ignore
                        pattern = new RegExp(_app.region.decimalSeparator + "(\\d+)$");
                    value = parseFloat(value.replace(pattern, '.$1'));

                    return value || fieldName;
                });
            
                //#.For checking the formula builder result is invalid.
                if (typeof (eval(expression)) !== 'string') {
                    result = eval(expression);
                }

                //#.Number formatting
                if (field.currency && field.currency.enabled) {
                    // @ts-ignore
                    const formatter = new Intl.NumberFormat(_app.region.default, {
                        style: 'decimal',
                        // @ts-ignore
                        currency: _app.currency.symbol,
                        minimumFractionDigits: context.currency.precision
                    });

                    //#.Re-assign the value to the model field
                    records[field.value] = formatter.format(result);
                }

                //#.Re-assign the value to the model field
                records[field.value] = result;
            }
        }
    }

    _numChange() {
        let context = this.$store.state[this.parentName];

        //#.Check is dirty
        context.isDirty = true;
    }

    /*
        * Method for show tooltip
    */
    _tpShowTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = true;
    }

    /*
        * Method for remove tooltip
    */
    _tpRemoveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = false;
        this.tooltipIcon = false;
    }   

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }

        this.translateKey = (this.$t(this.title) || this.title).toString();
        return this.translateKey;
    }
}  
